import moment from 'moment';

import { getCompletedPatientOncehubBookingsByNeurologist } from 'common-src/models/PatientOncehubBooking';
import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientLabOrders = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientLabOrder',
    (order) => order.patientId === patientId && !order.deletedAt,
  );

export const getFilteredPatientLabOrders = (state, patientId) => {
  const patientLabOrders = getPatientLabOrders(state, patientId);
  const neurologistVisits = getCompletedPatientOncehubBookingsByNeurologist(state, patientId);
  const lastVisit = neurologistVisits[0];
  const beforeLastVisit = neurologistVisits[1];

  if (!lastVisit || !beforeLastVisit) return patientLabOrders;

  return patientLabOrders.filter(
    (labOrder) =>
      moment(labOrder.updatedAt).isAfter(moment(beforeLastVisit.scheduledAt)) &&
      moment(labOrder.updatedAt).isBefore(moment(lastVisit.scheduledAt)),
  );
};
